"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// Generated from ../../../cs/src/Contracts/TunnelEndpoint.cs
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelEndpoint = exports.portToken = void 0;
/**
 * Token included in {@link TunnelEndpoint.portUriFormat} and {@link
 * TunnelEndpoint.portSshCommandFormat} that is to be replaced by a specified port number.
 */
exports.portToken = '{port}';
// Import static members from a non-generated file,
// and re-export them as an object with the same name as the interface.
const tunnelEndpointStatics_1 = require("./tunnelEndpointStatics");
exports.TunnelEndpoint = {
    portToken: exports.portToken,
    getPortUri: tunnelEndpointStatics_1.getPortUri,
    getPortSshCommand: tunnelEndpointStatics_1.getPortSshCommand,
};
//# sourceMappingURL=tunnelEndpoint.js.map